module.exports = __webpack_public_path__ + "assets/images/key/key_lon_syd_2021.svg?v=75cacd4b";